





































import { Component, Vue } from 'vue-property-decorator'

@Component
export default class StartNavigation extends Vue {
  public $smallScreen!: boolean

  private routeToMode(path: string): void {
    this.$router.push(`/${path}`)
  }
  get logoWidth () {
    return this.$smallScreen ? '200px' : '250px'
  }
}
